import { useEffect, useState } from 'react';
import { isEqual } from 'lodash';
import { Observable } from './observable.state.service';

// Based on https://blog.betomorrow.com/replacing-redux-with-observables-and-react-hooks-acdbbaf5ba80
export const useObservable = <T>(observable: Observable<T>): T | undefined => {
  const [val, setVal] = useState<T | undefined>(() => observable.get());

  useEffect(() => {
    const sync = (next: T | undefined) => setVal(() => next);

    if (!isEqual(observable.get(), val)) {
      sync(observable.get());
    }

    return observable.subscribe(sync);
  }, [observable]);

  return val;
};
